module.exports = __webpack_public_path__ + "static/turkbox1-b1b7ed20308aeb4c83af91e2f9b143f8.png";